import React from "react";
import Form, {
  Item,
  RequiredRule,
  Label,
  GroupItem,
  StringLengthRule,
} from "devextreme-react/form";
import { SelectBox } from "devextreme-react";
import { formatMessage } from "devextreme/localization";
import { useSelector, useDispatch } from "react-redux";
import { responseEmployee } from "../../../redux/reducers";
import { showEmployee } from "../../../redux/actions";
import Guid from "devextreme/core/guid";
import "./style.scss";
import { listApprovalType, changeDisplayedName } from "../../../common";

export default function FormApprovalSetting({ formData }) {
  const [approvalType, setApprovalType] = React.useState("");
  const [employeeType, setEmployeeType] = React.useState();
  const dispatch = useDispatch();
  const { employee } = useSelector(responseEmployee);

  React.useEffect(() => {
    dispatch(showEmployee());
  }, [dispatch]);
  React.useEffect(() => {
    if (formData.current.Employee) {
      const newEmployeeOid = new Guid(formData.current.Employee.Oid);
      setEmployeeType(newEmployeeOid);
      formData.current.EmployeeOid = newEmployeeOid;
    }
  }, [formData, formData.current.Employee]);

  function gridBoxEmployeeDisplayExpr(item) {
    return item && `${item.EmployeeCode} - ${item.FullName}`;
  }

  const dataTypeEditorOptions = {
    items: listApprovalType,
    searchEnabled: true,
    value: approvalType,
    displayExpr: changeDisplayedName(),
    valueExpr: "id",
    placeholder: formatMessage("PlaceholderApprovalType"),
    searchMode: "contains",
    showClearButton: true,
    onValueChanged: (e) => {
      setApprovalType(e.value);
    },
  };

  return (
    <div>
      <Form
        colCount={2}
        id="form"
        formData={formData.current}
        focusStateEnabled={true}
        className={"form-editor"}
        onContentReady={(e) => {
          e.component.focus();
        }}
      >
        <GroupItem>
          <Item
            dataField="ApprovalType"
            editorType="dxSelectBox"
            editorOptions={dataTypeEditorOptions}
          >
            <Label text={formatMessage("ApprovalType")} />
            <RequiredRule message={formatMessage("ValidateApprovalType")} />
          </Item>
          <Item dataField="Employee">
            <Label text="Employee" />
            <SelectBox
              valueExpr="Oid"
              dataSource={employee}
              value={employeeType}
              displayExpr={gridBoxEmployeeDisplayExpr}
              itemRender={gridBoxEmployeeDisplayExpr}
              onValueChanged={(e) => {
                formData.current.EmployeeOid = e.value;
                setEmployeeType(e.value);
              }}
              searchEnabled={true}
            />
            <RequiredRule message="Employee RequiredRule" />
          </Item>
        </GroupItem>
        <GroupItem>
          <Item dataField="Description" editorType="dxTextBox">
            <StringLengthRule max="250" />
            <Label text={formatMessage("Description")} />
          </Item>
          <Item dataField="IsActive" editorType="dxCheckBox">
            <Label text={formatMessage("IsActive")} />
          </Item>
        </GroupItem>
      </Form>
    </div>
  );
}
